import React from 'react';
import GenericSectionDashboard from '../GenericSectionDashboard';

const YarnDashboard = () => {
  return (
    <GenericSectionDashboard
      sectionName="Yarn Section"
      sectionId="yarn"
      sectionKey="Yarn"
      description="Yarn Inventory & Management"
      backRoute="/"
    />
  );
};

export default YarnDashboard;
